// extracted by mini-css-extract-plugin
export default {"dotSelected":"Navdots_dotSelected__Hnob3","dot":"Navdots_dot__jz+4A"};